import { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { X, Lock, Check, Loader2 } from "lucide-react";
import { createCheckout } from "../lib/api";

const PERKS = [
    "Acceso completo a todos los audios",
  "Audios narrados por Catalina",
  "Guía por voz durante 24 horas",
];

export const PaymentGate = ({ open, sessionId, onClose }) => {
  const [loading, setLoading] = useState(false);

  const pay = async () => {
    setLoading(true);
    try {
      const { checkout_url } = await createCheckout(sessionId);
      window.location.href = checkout_url;
    } catch (e) {
      setLoading(false);
    }
  };

  return (
    <AnimatePresence>
      {open && (
        <>
          <motion.div
            initial={{ opacity: 0 }} animate={{ opacity: 1 }} exit={{ opacity: 0 }}
            className="fixed inset-0 z-[700]" style={{ background: "rgba(5,6,9,0.7)" }} onClick={onClose}
          />
          <motion.div
            data-testid="payment-modal"
            initial={{ opacity: 0, scale: 0.94, y: 20 }}
            animate={{ opacity: 1, scale: 1, y: 0 }}
            exit={{ opacity: 0, scale: 0.94, y: 20 }}
            transition={{ type: "spring", damping: 26, stiffness: 320 }}
                        className="fixed top-8 left-1/2 z-[701] w-[90%] max-w-sm glass rounded-3xl p-7"
            style={{ x: "-50%" }}
          >
            <button data-testid="payment-close-btn" onClick={onClose} className="absolute top-4 right-4 w-9 h-9 rounded-full flex items-center justify-center" style={{ background: "rgba(255,255,255,0.06)" }}>
              <X size={18} style={{ color: "#9ca3af" }} />
            </button>

            <div className="w-14 h-14 rounded-2xl flex items-center justify-center gold-glow mb-4" style={{ background: "rgba(212,175,55,0.12)", border: "1px solid rgba(212,175,55,0.3)" }}>
              <Lock size={24} className="gold-text" />
            </div>

            <h3 className="font-serif-display text-3xl leading-none" style={{ color: "#f3f4f6" }}>
              Acceso a la audioguía
            </h3>
            <p className="mt-2 text-sm" style={{ color: "#9ca3af" }}>
              Un único pago para disfrutar de toda la ruta del Siglo de Oro.
            </p>

            <div className="my-6 space-y-3">
              {PERKS.map((p) => (
                <div key={p} className="flex items-center gap-3">
                  <div className="w-5 h-5 rounded-full flex items-center justify-center" style={{ background: "rgba(212,175,55,0.15)" }}>
                    <Check size={13} className="gold-text" />
                  </div>
                  <span className="text-sm" style={{ color: "#c7cad1" }}>{p}</span>
                </div>
              ))}
            </div>

            <div className="flex items-end gap-2 mb-5">
                            <span className="font-serif-display text-5xl" style={{ color: "#d4af37" }}>4,99 €</span>
              <span className="text-xs mb-2" style={{ color: "#6b7280" }}>/ acceso 24 h</span>
            </div>

            <button
              data-testid="payment-stripe-btn"
              onClick={pay}
              disabled={loading}
              className="btn-gold w-full rounded-full py-4 flex items-center justify-center gap-2 disabled:opacity-60"
            >
              {loading ? <><Loader2 size={18} className="animate-spin" /> Redirigiendo…</> : "Pagar con Stripe"}
            </button>
            <p className="mt-3 text-center text-[11px]" style={{ color: "#6b7280" }}>
                            Pago 100% seguro con Stripe
            </p>
          </motion.div>
        </>
      )}
    </AnimatePresence>
  );
};
